import React from "react";
import PropTypes from "prop-types";

export default function ViewSupplier({ viewObj }) {

    return (
        <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasRightView"
            aria-labelledby="offcanvasRightLabel"
            style={{ maxWidth: "45%" }}
        >
            <form>
                <div className="offcanvas-header d-flex justify-content-between align-items-center">
                    <h5 id="offcanvasRightLabel" className="mb-0">View Supplier</h5>
                    <div className="d-flex align-items-center">
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <hr/>
                <div className="offcanvas-body">
                    <div className="row">
                        <div className="col-6 mb-2">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={viewObj?.SupplierName}
                                readOnly
                            />
                        </div>
                        <div className="col-6 mb-2 position-relative">
                            <label className="form-label">
                                Email 
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={viewObj?.Email}
                                readOnly
                            />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label">Mobile</label>
                            <div className="input-group">
                                <span className="input-group-text">🇮🇳 +91</span>
                                <input
                                    type="tel"
                                    className="form-control"
                                    value={viewObj?.Phone}
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label">GST Number</label>
                            <input
                                type="text"
                                className="form-control"
                                value={viewObj?.GSTNumber}
                                readOnly
                            />
                        </div>
                        <div className="col-6 mb-2">
                            <label className="form-label">PAN Number</label>
                            <input
                                type="text"
                                className={`form-control`}
                                value={viewObj?.PANNumber}
                                readOnly
                            />
                        </div>
                        <div className="col-12 mb-2">
                            <label className="form-label">Address</label>
                            <textarea
                                className={`form-control`}
                                value={viewObj?.Address}
                                rows={4}
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}


ViewSupplier.propTypes = {
    editObj: PropTypes.object.isRequired,
};